import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./Nav.css";

const links = [
  { to: "/services", label: "Services" },
  { to: "/technology", label: "Technology" },
  { to: "/about", label: "Our Story" },
  { to: "/faq", label: "FAQ" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="container nav__inner">
        <Link to="/" className="nav__brand" onClick={() => setOpen(false)}>
          <img
            src="/images/logo.webp"
            alt="Brand Warehouse logo — ecommerce fulfillment in Rocklin, California"
            width="333"
            height="106"
          />
        </Link>

        <nav className="nav__links" aria-label="Primary">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className="nav__link">
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="nav__cta">
          <a
            href="tel:19166621333"
            className="nav__phone"
            data-webmcp-action="call-brand-warehouse"
            data-webmcp-description="Call Brand Warehouse at its confirmed business phone number"
            data-webmcp-inputs="none"
          >(916) 662-1333</a>
          <Link to="/quote" className="btn btn--green nav__quote">
            Get a Quote <span className="arrow">→</span>
          </Link>
        </div>

        <button
          className={`nav__burger ${open ? "is-open" : ""}`}
          aria-label="Menu"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span /><span /><span />
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            className="nav__mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          >
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/quote" className="btn btn--green" onClick={() => setOpen(false)}>
              Get a Quote →
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

